module.exports = __webpack_public_path__ + "img/mistake.edd85385.png";